import React from 'react';
import capitalise from '../../../utils/capitalise';

import { StationInfoObj, Template } from '../../types';

type StationHeaderProps = {
  stationInfo: StationInfoObj;
  template: Template;
};

export default function StationHeader({ stationInfo, template }: StationHeaderProps) {
  return (
    <>
      <section className="railSeoWrap__railTitle">
        <div className="makeFlex column appendTop15">
          <h1 className="font22 latoBold appendBottom5">{template.h1_title}</h1>
          <p className="font12 latoBold blackText">
            {stationInfo.city ? capitalise(stationInfo.city) + ',' : ''} {capitalise(stationInfo.name)}
          </p>
        </div>
      </section>
    </>
  );
}
